<p-toast></p-toast>
<div *ngIf="isDocumentVersionDateModalVisible" id="approvalStatusModal">
  <app-document-version-dates
  (closeApprovalModal)="reloadDocumentDetail()"
    (closeDocVersionModal)="handleDocVersionDatesModal($event)"
    [docEffectiveDate]="effectiveDate"
    [docRequestedEffectiveDate]="requestedEffectiveDate"
    [docPeriodicReviewCycle]="periodicReviewCycle"
    [documentVersion]="documentVersion"
    [documentNumber]="documentNumber"
    [docVersionApprover]="selectedDocApprover"
    [docPeriodicReviewDate]="periodicReviewDate"
    [isEsignDialogForApproval]="displayESignForApproval"
  >
  </app-document-version-dates>
</div>
<p-dialog
  [(visible)]="display"
  [style]="{ width: '95vw' }"
  (onHide)="reloadDocumentDetail()"
  [modal]="true"
  id="approvalStatusDateModal"
>
  <ng-template pTemplate="header">
    <app-read-only readonlyText="Approval Status"></app-read-only>
  </ng-template>

    <app-panel-list *ngIf = "!showLoader" [panelList]="approvalStatusData" [noResultFound] = "noData">
      <ng-template #templateRef let-data="dataVar">
        <div panel-content>
          <div class="grid">
            <div class="col-10">
              <div class="grid">
                <div class="col-6 text-left">
                  <app-label labelText="Approver"></app-label>
                  <app-read-only [ngClass]="{'inActiveGroup': data?.isApproverTerminated===true}"
                    readonlyText="{{ data?.approver }}"
                  ></app-read-only>
                </div>
                <div class="col-3 text-left">
                  <app-label labelText="Status"></app-label>
                  <div class="grid">
                    <div class="col max-w-0">
                      <em
                        class="pi pi-circle-fill"
                        [ngClass]="{
                          pending: data?.status == 0,
                          completed: data?.status == 1
                        }"
                      ></em>
                    </div>
                    <div class="col ml-1">
                      <app-read-only
                        readonlyText="{{ data?.statusName }}"
                      ></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="col-3 text-left">
                  <app-label labelText="Approved Date"></app-label>
                  <app-read-only
                    readonlyText="{{
                      data?.approvedDate | date : 'dd-MMM-yyyy'
                    }}"
                  ></app-read-only>
                </div>
                <div class="col-12" *ngIf="data?.delegateTo?.length > 0">
                  <div class="mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Delegate To' }}"></app-label>
                    <div *ngFor="let delegateApprover of data.delegatedToInformation">
                      <app-read-only [ngClass]="{'inActiveGroup': delegateApprover.isTerminated===true}"
                        readonlyText="{{ delegateApprover.name }}"
                      ></app-read-only>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <div class="col-2 text-left" *ngIf="data?.approveButtonFlag && showApproveButton  && !showApproveButtonWhenFileCheckedOut">
              <p-button
              appPreventDoubleClick
                label="Approve"
                icon="fas fa-check"
                id="approvalStatusButton"
                (debounceClick)="approveDocument(data?.approver)"
                iconPos="left"
              ></p-button>
            </div>
          </div>
        </div>
      </ng-template>
    </app-panel-list>

</p-dialog>

<p-dialog
  [(visible)]="showEsignatureConfirmationDialog"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ confirmationMessage }}</span>
  </div>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="closeEsignature"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="saveEsignature"
      class="align-right"
      (debounceClick)="onConfirm()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>

<div *ngIf="displayCRIHistoryModal" class="">
  <app-change-request-history-modal
    [documentDetailsDto]="documentDetailsDto"
    [isChangeRequestHistoryModalShow]="isChangeRequestHistoryModalShow"
    [isLatestVersion]="true"
    [documentPhase]="documentPhase"
    (isCloseChangeRequestItemHistoryModal)="
      closeChangeRequestItemHistoryModal($event)
    "
    (isLatestDocument)="updateIsLatestVersion($event)"
    [isTriggeredFromApproval]="isTriggeredFromApproval"
    (isApprovalStatusModalVisible)="
      updateCRIItemStatusToDeferAndProceed($event)
    "
  >
  </app-change-request-history-modal>
</div>
